var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6668 8.5332L9.4668 12.2665C9.73346 12.5332 10.1335 12.5332 10.4001 12.2665C10.6668 11.9999 10.6668 11.5999 10.4001 11.3332L7.13346 7.99987L10.4001 4.66654C10.6668 4.39987 10.6668 3.99987 10.4001 3.7332C10.2668 3.59987 10.1335 3.5332 9.93346 3.5332C9.73346 3.5332 9.60013 3.59987 9.4668 3.7332L5.6668 7.46654C5.40013 7.79987 5.40013 8.19987 5.6668 8.5332C5.6668 8.46654 5.6668 8.46654 5.6668 8.5332Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4V12",
    stroke: "#fff",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPageIcon);
export default __webpack_public_path__ + "static/media/first-page-icon.5ff2a7e7ca95eee75a59687d59842fbe.svg";
export { ForwardRef as ReactComponent };